import { Dayjs } from 'dayjs'

const GOOGLE_CALENDAR_RENDER_URL = 'https://calendar.google.com/calendar/render'

interface GoogleCalendarLinkParams {
  startDt: Dayjs
  endDt: Dayjs
  /** All-day events use date-only ranges; timed events use UTC timestamps. */
  allDay: boolean
  /** Event title (caller resolves an i18n fallback before passing it in). */
  text: string
  details?: string
  location?: string
}

/**
 * Builds a Google Calendar "render?action=TEMPLATE" URL pre-filled with the
 * event, so the user can add it to their own agenda in one click (no OAuth).
 *
 * Date formatting mirrors Google's expectations:
 * - all-day: `YYYYMMDD/YYYYMMDD` with the end exclusive (+1 day)
 * - timed:   `YYYYMMDDTHHmmssZ/YYYYMMDDTHHmmssZ` in UTC
 */
export function buildGoogleCalendarUrl({
  startDt,
  endDt,
  allDay,
  text,
  details = '',
  location = '',
}: GoogleCalendarLinkParams): string {
  const dates = allDay
    ? `${startDt.format('YYYYMMDD')}/${endDt.add(1, 'day').format('YYYYMMDD')}`
    : `${startDt.utc().format('YYYYMMDDTHHmmss')}Z/${endDt.utc().format('YYYYMMDDTHHmmss')}Z`

  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text,
    dates,
    details,
    location,
  })

  return `${GOOGLE_CALENDAR_RENDER_URL}?${params.toString()}`
}
